import july2026UpdateImg from '../assets/LayerAttributesJuly2026.png';
import type { FeatureAnnouncementContent } from '../types';

export const july2026Update: FeatureAnnouncementContent = {
  announcementTitle: 'CivilGrid Product Update, July 2026',
  announcementSubtitle:
    'Feature data is now easier to explore, so you can verify site conditions without leaving the map.',
  announcementId: 'july-2026-product-update',
  featureTitle: 'Introducing Layer Attributes',
  featureDescription:
    'Metadata is now <b>Layer Attributes</b>, a clearer name for everything a feature can tell you beyond its location and geometry.',
  image: {
    src: july2026UpdateImg,
    alt: 'The Layer Attributes panel: click-to-inspect, multi-feature area mode, and the map-label toggle',
  },
  featureItems: [
    {
      title: 'Click to Inspect',
      testId: 'click-to-inspect',
      description: 'Click any feature to open the Layer Attributes panel, with the feature highlighted on the map.',
    },
    {
      title: 'Explore Dense Areas',
      testId: 'explore-dense-areas',
      description:
        'Right-click a cluster of features to open all of them in the panel. Scroll the list to highlight each on the map; click a layer name to collapse or expand its attributes.',
    },
    {
      title: 'Control Map Labels',
      testId: 'control-map-labels',
      description: "Toggle the 👁️ icon to show or hide an attribute's label on the map.",
    },
  ],
};
